import LocalStore from '../app/store/LocalStore';
import SessionStore from '../app/store/SessionStore';
export var localStore = new LocalStore();
export var sessionStore = new SessionStore();
